import type { FC } from "react";
import { useProductGroups } from "../../dictionaries/useProductGroups";
import FormSelect from "../../../components/formComponents/FormSelect";
import type { Control, FieldPath } from "react-hook-form";
import type { ProductFormState } from "./ProductEdit";

interface Props {
  readonly name: FieldPath<ProductFormState>;
  readonly control: Control<ProductFormState>;
}

const ProductsGroup: FC<Props> = ({ name, control }) => {
  const { productGroups } = useProductGroups();
  return (
    <FormSelect
      label="Grupa produktów"
      name={name}
      control={control}
      options={productGroups.map(({ name }) => ({ value: name, label: name }))}
    />
  );
};

export default ProductsGroup;
